import api from "core/api";
import asyncThunk from "core/decorators/toolkit";

export const updateStoreUser = asyncThunk("wizard/update/user", api.users.update);
